module.exports = __webpack_public_path__ + "static/media/navy_camo.68af8183.jpg";